import React from 'react';
import "./VisionPoints.css";
import {Container} from "react-bootstrap";

const MissionStatement = (prop) => {

    return (
        <>
            <Container fluid={true} className={'vision py-5 beige'}>
                <Container className="vision horizontal">
                    <div className="vision-head mx-auto">
                        <blockquote className="blockquote text-center d-flex flex-column gap-4">
                            <p className="mb-0 fs-15" style={{fontSize: '32px'}}>"We are not just allocating capital—we are actively architecting the future of business.”</p>
                            <footer className="blockquote-footer" style={{fontSize: '24px'}}><cite title="Source Title">Jonathan Tjoa Algreen, Founder of iBig</cite></footer>
                        </blockquote>
                    </div>
                </Container>
            </Container>
        </>
    );
};

export default MissionStatement;
